import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as WalkerActions from "../../store/actions/Walker";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const WalkerDashboard = ({ getBulkUploadUrl }) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="WalkerBtn"
      uploadUrl="/walker/bulk/onboarding/ack"
      sampleURL="/sample/bulk_walker_onboarding.csv"
      id="WalkerModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Bulk Walker Onboarding"
      getUploadUrl={getBulkUploadUrl}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getBulkUploadUrl: bindActionCreators(WalkerActions.getUploadUrl, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(WalkerDashboard);
